import { ChangeDetectionStrategy, Component, computed, inject, input, model } from '@angular/core';
import { HeaderDistruzioneOperazioniMassive, SummaryDocumentoToDestroy } from '../models/operazioni-massive.model';
import { MenuItem } from 'primeng/api';
import { DestroyReportFileFormat } from '../models/operazioni-massive-service.model';
import { OperazioniMassiveService } from '../services/operazioni-massive.service';

@Component({
  selector: 'app-verbale-distruzione-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,  
  template: `
    <p-dialog [(visible)]="isOpen" [modal]="true" [closable]="false" [closeOnEscape]="false" [resizable]="false"  [style]="{ width: '60%', 'max-width':'760px' }">
      <p-header>
        @if( header().salvaSuRegistro) {
          <span>Verbale di Distruzione Documenti</span>
        }
        @if( !header().salvaSuRegistro) {
          <span>Riepilogo Distruzione Documenti</span>
        }        
      </p-header>
      <app-verbale-distruzione [protocol]="protocol()" [header]="header()" [documents]="documents()"></app-verbale-distruzione>
      <p-footer>
            <p-splitButton  [disabled]="!header || !documents().length"
                            icon="fas fa-download" [label]="labelReportButton()" (onClick)="print()" 
                            styleClass="pr-0 mr-0"
                            [model]="downloadCommands"/>

          <button pButton type="button" label="Chiudi" class="p-button-secondary ml-2" title="Chiudi" (click)="close()"></button>
      </p-footer>
    </p-dialog>
  `,
  styles: ` 
  ::ng-deep .p-dialog .p-dialog-footer button {width:unset; margin-right: 0px;}
  ::ng-deep .p-splitbutton-menubutton {padding:0 0.5rem}
  `
})
export class VerbaleDistruzioneDialogComponent {

  private readonly operazioniMassive = inject(OperazioniMassiveService);

  public id = input.required<number|undefined>();

  public protocol = input.required<string>();
  public header = input.required<HeaderDistruzioneOperazioniMassive>();
  public documents = input.required<SummaryDocumentoToDestroy[]>();
  public isOpen = model<boolean>(false);

  public downloadCommands: MenuItem[];

  public labelReportButton  = computed( () => (this.header().salvaSuRegistro)?'Scarica Verbale':'Scarica Riepilogo');

  constructor() {
    this.downloadCommands = [
      {
          label: 'Formato PDF',
          command: () => {
              this.print();
          }
      },
      {
          label: 'Formato Word',
          command: () => {
              this.printWord();
          }
      },
    ];  
  }

  public close(): void {
    this.isOpen.set(false);
  }
  
  public print(): void {
    this.generateReport( DestroyReportFileFormat.PDF);
  }

  public printWord(): void {
    this.generateReport( DestroyReportFileFormat.Word);
  }

  public generateReport( format: DestroyReportFileFormat = DestroyReportFileFormat.Word): void {
  
    setTimeout(() => {
      const operazioneId = this.id();
      
      if (operazioneId)
      {
        if(this.header().salvaSuRegistro)
          this.operazioniMassive.verbaleDistruzione(operazioneId, format);
        else
          this.operazioniMassive.report(operazioneId, format);
      }

    }, 100);
  }
}
